const tour = {
  actions: {
    startTour: "Démarrer la visite",
    takeAgain: "Revoir la visite",
  },
  ariaLabel: "Visites guidées",
  coachInterfaceIntro: {
    title: "Découvrez Coach AI",
    description:
      "Une courte introduction aux fonctions essentielles de Coach AI.",
    smokeDescription:
      "Cette brève animation de bienvenue est prête pour la visite complète de Coach AI.",
    desktop: {
      welcome: {
        title: "Bienvenue dans Coach AI",
        description:
          "Faites un rapide tour avant de commencer votre prochaine conversation sur la sécurité.",
      },
      scope: {
        title: "Définissez le périmètre",
        description:
          "Choisissez le client et le groupe de véhicules que Coach AI doit utiliser pour vos questions. Cela détermine les données disponibles pour Coach pendant la conversation, par exemple les rapports et les scores de performance liés aux excès de vitesse.",
      },
      sidebar: {
        title: "Naviguez depuis la barre",
        description:
          "Créez une conversation, consultez l'historique, réutilisez les prompts enregistrés, parcourez les suggestions du Coach, ajustez les paramètres ou revenez ici pour les visites.",
      },
      history: {
        title: "Revenez aux conversations récentes",
        description:
          "Consultez vos conversations précédentes avec Coach AI et exportez les réponses.",
      },
      savedPrompts: {
        title: "Réutilisez les questions utiles",
        description:
          "Les prompts enregistrés permettent de garder vos questions réutilisables préférées à portée de main. Double-cliquez sur un prompt pour l'envoyer.",
      },
      coachSuggestions: {
        title: "Utilisez les suggestions du Coach",
        description:
          "Parcourez des questions de sécurité prêtes à l'emploi dans les suggestions du Coach. Sélectionnez-en une pour l'envoyer à Coach AI.",
      },
      settings: {
        title: "Choisissez vos langues",
        description:
          "Définissez la langue de l'application et celle que Coach AI utilise dans ses réponses.",
      },
      composer: {
        title: "Commencez la conversation",
        description:
          "Posez une question de sécurité avec vos propres mots ou choisissez une suggestion pour commencer.",
      },
      closing: {
        title: "Vous êtes prêt à explorer",
        description:
          "Revenez aux Visites guidées pour revoir cette introduction ou découvrir une nouvelle visite.",
      },
    },
    mobile: {
      welcome: {
        title: "Bienvenue dans Coach AI",
        description:
          "Faites un rapide tour avant de commencer votre prochaine conversation sur la sécurité.",
      },
      scope: {
        title: "Définissez le périmètre",
        description:
          "Choisissez le client et le groupe de véhicules que Coach AI doit utiliser pour vos questions.",
      },
      sidebar: {
        title: "Ouvrez le menu",
        description:
          "Utilisez ce bouton pour ouvrir les conversations récentes, les prompts enregistrés, les suggestions du Coach, les paramètres et les visites guidées.",
      },
      history: {
        title: "Revenez aux conversations récentes",
        description:
          "Consultez vos conversations précédentes avec Coach AI et exportez les réponses.",
      },
      savedPrompts: {
        title: "Réutilisez les questions utiles",
        description:
          "Les prompts enregistrés permettent de garder vos questions réutilisables préférées à portée de main.",
      },
      coachSuggestions: {
        title: "Utilisez les suggestions du Coach",
        description:
          "Parcourez des questions de sécurité prêtes à l'emploi dans les suggestions du Coach. Sélectionnez-en une pour l'envoyer à Coach AI.",
      },
      settings: {
        title: "Choisissez vos langues",
        description:
          "Définissez la langue de l'application et celle que Coach AI utilise dans ses réponses.",
      },
      composer: {
        title: "Commencez la conversation",
        description:
          "Posez une question de sécurité avec vos propres mots ou choisissez une suggestion pour commencer.",
      },
      closing: {
        title: "Vous êtes prêt à explorer",
        description:
          "Revenez aux Visites guidées pour revoir cette introduction ou découvrir une nouvelle visite.",
      },
    },
  },
  errors: {
    loadFailed: "Impossible de charger les visites guidées.",
    completionFailed: "Impossible d'enregistrer la visite terminée.",
  },
  loading: "Chargement des visites guidées...",
  popover: {
    back: "Retour",
    close: "Fermer la visite",
    done: "Terminer",
    next: "Suivant",
    progress: "Étape {{current}} sur {{total}}",
  },
  status: {
    completed: "Terminée",
    notStarted: "Pas commencée",
  },
} as const;

export default tour;
